
import { supabase } from '@/integrations/supabase/client';

export const getLeadsQuery = (companyId?: string) => {
  let query = supabase
    .from('leads')
    .select(`
      id,
      name,
      address,
      category,
      email,
      phone,
      website,
      image_url,
      is_favorite,
      rating,
      review_count,
      status,
      latitude,
      longitude,
      web_search_status,
      web_search_queue_time,
      web_search_data,
      web_search_updated_at,
      web_search_retry_count,
      web_search_last_error,
      combined_data,
      combined_updated_at,
      deep_research_status,
      deep_research_updated_at,
      crawl_status,
      crawl_updated_at,
      sector,
      last_contacted_at,
      company_id,
      place_id,
      created_by,
      created_at,
      updated_at,
      notes:notes (
        id,
        content,
        created_at,
        created_by,
        lead_id,
        tags,
        updated_at
      ),
      documents:documents (
        id,
        name,
        url,
        type,
        description,
        lead_id,
        created_at,
        uploaded_by
      ),
      lead_images:lead_images (
        id,
        image_url,
        is_primary,
        position,
        created_at
      ),
      lead_key_contacts:lead_key_contacts (
        id,
        name,
        email,
        phone,
        position,
        is_primary,
        notes,
        created_at,
        created_by,
        linkedin_url,
        source,
        status
      )
    `);
    
  // Always filter by companyId
  if (companyId) {
    query = query.eq('company_id', companyId);
  } else {
    // If no companyId, add impossible filter to return empty set
    query = query.eq('company_id', '00000000-0000-0000-0000-000000000000');
  }
  
  return query;
};
